import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from "contentful";
import type { TypeAccordionItemSkeleton } from "./TypeAccordionItem";
import type { TypeTableOfContentsSettingSkeleton } from "./TypeTableOfContentsSetting";

/**
 * Fields type definition for content type 'TypeAccordionSection'
 * @name TypeAccordionSectionFields
 * @type {TypeAccordionSectionFields}
 * @memberof TypeAccordionSection
 */
export interface TypeAccordionSectionFields {
    /**
     * Field type definition for field 'internalTitle' (Internal Title)
     * @name Internal Title
     * @localized false
     */
    internalTitle?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'header' (Header)
     * @name Header
     * @localized true
     */
    header?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'subHeader' (Sub Header)
     * @name Sub Header
     * @localized true
     */
    subHeader?: EntryFieldTypes.Symbol;
    /**
     * Field type definition for field 'backgroundColor' (Background Color)
     * @name Background Color
     * @localized false
     */
    backgroundColor: EntryFieldTypes.Symbol<"grey" | "light-blue" | "white">;
    /**
     * Field type definition for field 'items' (Items)
     * @name Items
     * @localized false
     */
    items?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeAccordionItemSkeleton>>;
    /**
     * Field type definition for field 'tocSetting' (tocSetting)
     * @name tocSetting
     * @localized false
     */
    tocSetting?: EntryFieldTypes.EntryLink<TypeTableOfContentsSettingSkeleton>;
}

/**
 * Entry skeleton type definition for content type 'accordionSection' (Accordion Section)
 * @name TypeAccordionSectionSkeleton
 * @type {TypeAccordionSectionSkeleton}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2022-02-22T13:05:54.606Z
 * @version 17
 */
export type TypeAccordionSectionSkeleton = EntrySkeletonType<TypeAccordionSectionFields, "accordionSection">;
/**
 * Entry type definition for content type 'accordionSection' (Accordion Section)
 * @name TypeAccordionSection
 * @type {TypeAccordionSection}
 * @author 1elSikqsztE4ExkC29eZFE
 * @since 2022-02-22T13:05:54.606Z
 * @version 17
 */
export type TypeAccordionSection<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<TypeAccordionSectionSkeleton, Modifiers, Locales>;

export function isTypeAccordionSection<Modifiers extends ChainModifiers, Locales extends LocaleCode>(entry: Entry<EntrySkeletonType, Modifiers, Locales>): entry is TypeAccordionSection<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'accordionSection'
}
